export const SET_EVENTS_FILTER = 'EVENTS/SET_FILTER'
export const SET_EVENT_VIEW_TYPE = 'EVENTS/SET_EVENT_VIEW_TYPE'
export const CHANGE_PAGE = 'EVENTS/CHANGE_PAGE'
export const SET_EVENTS_EXPANDED = 'EVENTS/SET_EVENTS_EXPANDED'
export const SET_CALENDAR_VIEW_TYPE = 'EVENTS/SET_CALENDAR_VIEW_TYPE'
export const SET_CALENDAR_LAST_DATE = 'EVENTS/SET_CALENDAR_LAST_DATE'